$(function () {
	if ($('#uber').hasClass('interior')) {
		// Add class to uber if calendar template
		if ($('#CalendarTemplate').length > 0) {
			$('#uber').addClass('calendarView');
		}

		var win = $(window);

		win.on('load resize', function () {
			var sideWidgets = [
				'#contactMainContainer',
				'#pageSubscription'
			];

			if (win.width() >= 992) {
				resetMoveSideWidgets(sideWidgets);
			} else {
				moveSideWidgets(sideWidgets);
			}
		});

		function moveSideWidgets(el) {
			if (el !== undefined || el !== null) {
				for (var i = 0; i < el.length; i++) {
					var me = el[i];

					if ($('#subNavWrapper').find(me).length) {
						$('#subNavWrapper').find(me).detach().appendTo('#printArea');
					}
				}
			}
		}

		function resetMoveSideWidgets(el) {
			if (el !== undefined || el !== null) {
				for (var i = 0; i < el.length; i++) {
					var me = el[i];

					if ($('#printArea').find(me).length) {
						$('#printArea').find(me).detach().appendTo('#subNavWrapper');
					}
				}
			}
		}
	}
});
